const MOBILE_USER_AGENT_KEYWORDS = [
    'android',
    'webos',
    'iphone',
    'ipad',
    'ipod',
    'blackberry',
    'windows phone'
]

/**
 * Мобильное устройство по строке userAgent (без учёта touch/размера экрана).
 * iPadOS 13+ маскируется под Macintosh в userAgent, поэтому современный iPad
 * сюда НЕ попадает — 'ipad' в списке ловит только старые версии iPadOS/приложения,
 * явно просящие мобильную версию сайта.
 */
export function isMobileUserAgent(): boolean {
    const userAgent = navigator.userAgent.toLowerCase()
    return MOBILE_USER_AGENT_KEYWORDS.some(keyword => userAgent.includes(keyword))
}

let _isMobileCache: boolean | null = null

export function isMobile(): boolean {
    if (_isMobileCache !== null) return _isMobileCache

    const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0
    const isSmallScreen = window.innerWidth < 768

    _isMobileCache = isMobileUserAgent() || (hasTouch && isSmallScreen)
    return _isMobileCache
}

export function isIOS(): boolean {
    const ua = navigator.userAgent
    if (/iPad|iPhone|iPod/.test(ua)) return true
    // iPadOS 13+ маскируется под macOS, но имеет multi-touch
    return ua.includes('Macintosh') && navigator.maxTouchPoints > 1
}
